module.exports = __webpack_public_path__ + "static/media/chevron-left-blue-ic.799517ad.svg";